import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class FlagListState extends PaginatedListState {
  constructor(app) {
    super({}, 1, null);
    _defineProperty(this, "app", void 0);
    this.app = app;
  }
  get type() {
    return 'flags';
  }

  /**
   * Load flags into the application's cache if they haven't already
   * been loaded.
   */
  load() {
    var _this$app$session$use;
    if ((_this$app$session$use = this.app.session.user) != null && _this$app$session$use.attribute('newFlagCount')) {
      this.pages = [];
      this.location = {
        page: 1
      };
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    return super.loadNext();
  }
}
flarum.reg.add('flarum-flags', 'forum/states/FlagListState', FlagListState);